import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ControlViewModelBuilder from '@/Builder/ControlViewModelBuilder';
import { ILabelViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import Utilities from '@/Utility/Utilities';

export default class LabelViewModelBuilder<T = null> extends ControlViewModelBuilder<LabelViewModelT, T>{

    protected properties: ILabelViewModelConstructorParameter;
    protected replacementBuilder: { [key: string]: LabelViewModelBuilder<any> }
    protected prefixBuilder: LabelViewModelBuilder<any>;
    protected postfixBuilder: LabelViewModelBuilder<any>;
    
    public constructor(parent?: T) {
        super(parent);
        this.replacementBuilder = {};
    }

    public withErgName(ergName: ObservableOrDefault<string>): this {
        this.properties.ergName = ergName;
        return this;
    }

    public withCaption(caption: ObservableOrDefault<string>): this {
        this.properties.caption = caption;
        return this;
    }

    public withSimpleReplacement(placeholder: string, replacement: string): this {
        if (Utilities.isNullOrUndefined(this.properties.replacements))
            this.properties.replacements = {};
        this.properties.replacements[placeholder] = replacement;

        return this;
    }

    public withReplacement(key: string): LabelViewModelBuilder<this> {
        this.replacementBuilder[key] = new LabelViewModelBuilder<this>(this);
        return this.replacementBuilder[key];
    }

    public withPrefix(): LabelViewModelBuilder<this> {
        if (this.prefixBuilder == null)
            this.prefixBuilder = new LabelViewModelBuilder<this>(this);

        return this.prefixBuilder;
    }

    public withPostfix(): LabelViewModelBuilder<this> {
        if (this.postfixBuilder == null)
            this.postfixBuilder = new LabelViewModelBuilder<this>(this);

        return this.postfixBuilder;
    }

    public updateProperties(properties: Partial<ILabelViewModelConstructorParameter>): this {
        $.extend(this.properties, properties);
        return this;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected preBuild(): void {
        const replacementBuilder = this.replacementBuilder;
        for (const key in replacementBuilder) {
            if (replacementBuilder.hasOwnProperty(key)) {
                const builder = this.replacementBuilder[key];
                this.properties.replacements[key] = builder.build();
            }
        }
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): LabelViewModelT {
        if (this.prefixBuilder != null)
            this.properties.prefix = this.prefixBuilder.build();

        if (this.postfixBuilder != null)
            this.properties.postfix = this.postfixBuilder.build();

        const LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

        return new LabelViewModel(this.properties);
    }
}

ComponentManager.setUtility('LabelViewModelBuilder', LabelViewModelBuilder, 'RADPresentation.HTMLClient.DefaultViewExtensions');